import React, { useContext, useState, useEffect, useCallback } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import styled, { ThemeContext }  from 'styled-components'
import { TYPE } from '../../theme'
// import Web3 from 'web3'
// import { provider } from 'web3-core'

// import { Text } from 'rebass'

// components
// import { BodyHead, BodyTitle } from '../../components/bakery/styleds'
import Row, { RowBetween, AutoRow } from '../../components/Row'
import LaunchInput, { LaunchText } from '../BakeryArtworks/components/LaunchInput'
import { ButtonConfirmed } from '../../components/Button'
import Loader from '../../components/Loader'
import LaunchErr from '../BakeryArtworks/components/LaunchErr'
import NewUpLoadFiles from '../BakeryArtworks/components/NewUpLoadFiles'

// hooks
import { useActiveWeb3React } from '../../hooks'
import { useAddPopup } from '../../state/application/hooks'
import useParsedQueryString from '../../hooks/useParsedQueryString'

// constants
import { editInfo, imgErr } from '../../constants/usercenter/editInfo'
import { linkExp } from '../../constants/artwork'
import { userInfo, userInfoDefault } from '../../constants/usercenter'

// service
import { getSignature, uploadKycImg} from '../../service/appService'
import { addArtists, getArtistInfo, getArtist } from '../../service/user'

import { deepCopy } from '../../utils/func'

const PersonalWrapper = styled.div`
  padding: 48px 120px 62px;
  width: 940px;
  background: ${({ theme }) => theme.bsBg36};
  box-shadow: 0px 2px 10px ${({theme}) => !theme.darkMode ? 'rgba(171, 133, 115, 0.1)' : 'rgba(171, 133, 115, 0)'};
  border-radius: 32px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin: 0 10px;
    padding: 20px 24px;
    min-width: 328px;
    max-width: 95%;
  `}
  .inputFile {
    display: none;
  }
`
const FormItem = styled(Row)<{ width?: string; height?: string }>`
  position: relative;
  flex-direction: column;
  align-items: flex-start;
  width: ${({ width }) => (width ? width : '100%')};
  min-height: ${({ height }) => (height ? height : '108px')};
  .errShow {
    height: 20px;
  }
  .support {
    width: 210px;
    font-family: Yuanti SC;
    font-weight: normal;
    font-size: 14px;
    white-space: pre-line;
    color: ${({ theme }) => theme.bsText5};
  }
  .cover {
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0px;
    right: 0;
    transition: background .2s linear;
    z-index: 1;
    cursor: pointer;
    img, .support{
      opacity: 0;
      transition: opacity .2s linear;
    }
    img {
      width: 32px;
      height: 34px;
    }
    .support {
      color: white;
    }
  }
`
const FormRowBetween = styled(RowBetween)`
  align-items: flex-start;
  /* border-bottom: 1px solid ${({ theme }) => theme.bsBorder2}; */
  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: column;
  `}
`
// const ItemImg = styled.div`
//   position: relative;
//   flex-shrink: 0;
//   margin-right: 27px;
//   width: 102px;
//   height: 102px;
//   border-radius: 102px;
//   overflow: hidden;
//   img {
//     width: 102px;
//     height: 102px;
//     display: block;
//   }
//   &:hover {
//     .cover {
//       background: rgba(172, 86, 42, 0.8);
//       img {
//         opacity: 1;
//       }
//     }
//   }
// `
const TextareaLimit = styled.div`
  position: absolute;
  bottom: 35px;
  right: 24px;
  font-family: Baloo Da;
  font-size: 12px;
  color: ${({ theme }) => theme.bsText10};
`
// const ItemBannerHolder = styled(Row)`
//   padding: 20px 24px;
//   width: 592px;
//   height: 104px;
//   background: ${({ theme }) => theme.bsBg19};
//   border: 2px dashed ${({ theme }) => theme.bsBorder2};
//   border-radius: 10px;
//   img {
//     margin-right: 48px;
//     flex-shrink: 0;
//     width: 64px;
//     height: 64px;
//     cursor: pointer;
//   }
//   ${({ theme }) => theme.mediaWidth.upToMedium`
//     padding: 10px 14px;
//     width: auto;
//     img {
//       margin-right: 10px;
//     }
//   `}
// `
// const ItemBanner = styled.div`
//   position: relative;
//   width: 592px;
//   height: 118px;
//   border-radius: 10px;
//   overflow: hidden;
//   img {
//     width: 100%;
//     height: 100%;
//     cursor: pointer;
//   }
//   &:hover {
//     .cover {
//       background: rgba(172, 86, 42, 0.8);
//       .support {
//         opacity: 1;
//       }
//     }
//   }
//   ${({ theme }) => theme.mediaWidth.upToMedium`
//     width: auto;
//   `}
// `
const UseLoading = styled.div`
  font-family: Baloo Da;
  color: ${({ theme }) => theme.bsText7};
  font-size: 14px;
`
const Button = styled(ButtonConfirmed)<{isDisabled?: boolean}>`
  border: none;
  font-size: 16px;
  width: 100%;
  height: 56px;
  font-family: 'Roboto-Bold';
  border-radius: 8px;
  text-align: cneter;
  padding: 0;
  color: ${({ theme }) => theme.bsText25}!important;
  background: ${({ isDisabled, theme }) => !isDisabled ? theme.btnBg3 : theme.bsBg34};
`

export default function UserCenter ({
  match: {
    params: { owner }
  }
}: RouteComponentProps<{ owner: string}>)  {
  const theme = useContext(ThemeContext)
  const [curUserInfo, setUserInfo] = useState({...deepCopy(editInfo)})
  const [briefNum, setBriefNum] = useState(0)
  const { account, chainId, library } = useActiveWeb3React()
  const query:any = useParsedQueryString()
  const [submit, setSubmit] = useState(true)
  const [resloading, setResloading] = useState(false)
  const [userArt, setUserArt] = useState([])

  const getArtistList = useCallback(() => {
    getArtist(chainId as number, {addressTypes: '4'}, (err: any, d: any) => {
      if (!err && d.code === 0) {
        const list = d.data || []
        const artistList = list.length ? list : userInfo
        setUserArt(artistList.filter((d: any) => d.address.toLowerCase() === owner.toLowerCase()))
      }
    })
  }, [chainId, owner])

  // 获取信息
  const getUserInfo = () => {
    getArtistInfo(chainId as number, {address: owner}, (err: any, d: any) => {
      let info = {...curUserInfo}
      if (!err && d.code === 0) {
        for (const key in d.data) {
          if (Object.prototype.hasOwnProperty.call(d.data, key)) {
            const element = info[key]
            element.text = d.data[key]
            if (key === 'avatar' || key === 'banner') {
              element.file = d.data[key]
            }
          }
        }
      } else {
        let exInfo = {...userInfoDefault, name: (query.artist || ''), introduction: 'Please write something about yourself'}
        if (userArt.length > 0) {
          const ob = userArt[0]
          exInfo = ob
        }
        info.nick.text = exInfo.name
        info.avatar.text = exInfo.avatar
        info.avatar.file = exInfo.avatar
        info.banner.text = exInfo.bgImg
        info.banner.file = exInfo.bgImg
        info.introduction.text = exInfo.introduction
        info.link.text = exInfo.link
      }
      setUserInfo(info)
    })
  }

  useEffect(() => {
    if (owner) {
      getUserInfo()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [owner])

  // 检查信息是否完整
  useEffect(() => {
    checkInfo(curUserInfo)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curUserInfo])

  useEffect(() => {
    getArtistList()
  }, [chainId, getArtistList])
  
  const checkInfo = (info: any) => {
    setSubmit(false)
    for (const key in info) {
      if (info.hasOwnProperty(key)) {
        const element = info[key]
        if (key !== 'link' && (!element.text || (element.text && +element.text === 0) || element.errShow)) {
          setSubmit(true)
        }
        if (key === 'link' && element.errShow) {
          setSubmit(true)
        }
        if ((key === 'avatar' || key === 'banner') && (element.loading || !element.file)) {
          setSubmit(true)
        }
      }
    }
  }

  const inputChange = (type: any, e: any) => {
    const info = { ...curUserInfo }
    if (type === 'nick') {
      info[type].text = e.target.value.slice(0, 100)
    } else if (type === 'introduction') {
      info[type].text = e.target.value.slice(0, (userArt.length > 0 ? 1000 : 500))
      setBriefNum(info[type].text.length)
    } else if (type === 'link') {
      info[type].text = e.target.value.trim()
    } else {
      info[type].text = e.target.value
    }
    inputBlur(type)
  }

  const inputBlur = (type: any) => {
    const info = { ...curUserInfo }
    if (info[type].text.trim()) {
      info[type].errShow = false
      if (type === 'link') {
        if (!linkExp.test((info[type].text))) {
          info[type].err = 'Invalid profile link'
          info[type].errShow = true
        } else {
          info[type].err = ''
          info[type].errShow = false
        }
      }
    } else {
      info[type].errShow = true
      if (type === 'link') {
        info[type].err = ''
        info[type].errShow = false
      }
    }
    setUserInfo(info)
  }

  const resetUserInfo = (type: any, err: any, show: boolean, loading?: boolean, src?: string, file?: string) => {
    const info = { ...curUserInfo }
    info[type].err = err
    info[type].errShow = show
    info[type].text = src ? src : info[type].text
    info[type].file = file ? file : info[type].file
    if (loading) {
      info[type].loading = loading
    } else {
      info[type].loading = false
    }
    setUserInfo(info)
  }

  // 校验图片
  const verififyFile = (file: any, type: string) => {
    if (!file) return
    const name = file.name
    if (!/\.(png|jpg|jpeg)/i.test(name)) {
      return false
    }
    if (file.size > imgErr[type].size) {
      resetUserInfo(type, imgErr[type].errSize, true)
      return false
    } else {
      resetUserInfo(type, imgErr[type].errSize, false)
    }
    return true
  }

  const uploadImg = (type: string) => {
    let dom: any = null
    dom = document.getElementById(type)
    dom.value = ''
    dom.click()
  }

  // 上传文件
  const uploadIdImg = (e: any, type: string) => {
    const files = e.target.files
    if (!files) return
    let verifify = !verififyFile(files[0], type)
    const format = files[0].name
      ? files[0].name.split('.').slice(-1)[0]
      : files[0].type.split('/')[1]
    const ready = new FileReader()
    const img = new Image()
    img.onload = function() {
      if (verifify) {
        resetUserInfo(type, curUserInfo[type].err, true, false, img.src)
      } else {
        getFileSignature(files[0], type, format, img.src)
      }
    }
    ready.onload = function(event: any) {
      img.src = event.target.result
    }
    ready.readAsDataURL(files[0])
  }
 
  // 获取签名
  const getFileSignature = (file: any, type: string, format: string, src: string) => {
    let params  ={
      suffix: format
    }
    resetUserInfo(type, imgErr[type].err, false, true, src)
    getSignature(chainId as number, params, (err: any, d: any) => {
      if (err || d.code !== 0) {
        resetUserInfo(type, imgErr[type].err, false, false, '')
        return
      }
      const url = d.data.url
      const fields = d.data.fields
      var data = new FormData()
      Object.keys(fields).forEach((key) => {
        data.append(key, fields[key])
      })
      data.append('file', file)
      uploadKycImg(url, data, (err: any, res: any) => {
        resetUserInfo(type, imgErr[type].err, false, false, '')
        if (err) return
        resetUserInfo(type, imgErr[type].err, false, false, '', d.data.fileUrl)
        console.log('res', res)
      })
    })
  }

  const addPopup = useAddPopup()
  const submitHandle = () => {
    if (!library) return
    setResloading(true)
    let time = Math.round(Date.now()/1000).toString()
    const message = curUserInfo.nick.text + "-" + time

    // const ethereum = library?.provider
    // const web3 = new Web3(ethereum as provider)
    // let msg = web3.utils.toHex(message)
    // console.log("---msg---",msg)
    
    library
      .send('personal_sign', [owner, message])
      .then(signature => {
        let param = {
          address: owner,
          avatar: curUserInfo.avatar.file,
          nick: curUserInfo.nick.text,
          link: curUserInfo.link.text || undefined,
          introduction: curUserInfo.introduction.text,
          banner: curUserInfo.banner.file,
          timestamp: time,
          signature: signature
        }
        addArtists(chainId as number, param, (err: any, d: any) => {
          setResloading(false)
          if (err) {
            addPopup(
              {
                txn: {
                  hash: '',
                  success: false,
                  summary: 'Error'
                }
              }
            )
            return
          }
          if (d.code !== 0) {
            addPopup(
              {
                txn: {
                  hash: '',
                  success: false,
                  summary: 'Code Error'
                }
              }
            )
            return
          }
          addPopup(
            {
              txn: {
                hash: '',
                success: d.code === 0,
                summary: 'Success'
              }
            }
          )
        })
      })
      .catch(error => {
        setResloading(false)
        console.log('err', error)
        addPopup(
          {
            txn: {
              hash: '',
              success: false,
              summary: 'Fail'
            }
          }
        )
      })
  }


  return (
    <>
      {/* <BodyHead>
        <BodyTitle fontSize={32} marginTop={20}>
          Edit Profile
        </BodyTitle>
      </BodyHead> */}
      <PersonalWrapper>
        <TYPE.mediumHeader
          color={theme.bsText37}
          fontFamily="Roboto-Bold"
          fontSize={32}
          marginBottom={48}
        >
          Edit Profile
        </TYPE.mediumHeader>
        <FormRowBetween>
          <FormItem style={{width: '174px', height: '188px', flexShrink: 0}}>
            {/* <ItemImg>
              <img src={curUserInfo.avatar.text} alt=""/>
              <Row className="cover" onClick={() => uploadImg('avatar')}>
                <img src="images/user/edit_avatar.png" alt=""/>
                <input
                  type="file"
                  accept=".jpg, .png, .jpeg"
                  id="avatar"
                  className="inputFile"
                  onChange={event => {
                    uploadIdImg(event, 'avatar')
                  }}
                />
              </Row>
            </ItemImg> */}
            <LaunchText info={curUserInfo.avatar} title="Avatar" margin="0 0 8px"></LaunchText>
            <NewUpLoadFiles
              info={{...curUserInfo.avatar}}
              type="avatar"
              uploadImg={uploadImg}
              uploadIdImg={uploadIdImg}
              accept=".jpg, .png, .jpeg"
              cssDetail={{width: '118px', height: '118px', iconSize: '37px'}}></NewUpLoadFiles>
            {
              curUserInfo.avatar.loading && <UseLoading style={{paddingLeft: '15px'}}>uploading...</UseLoading>
            }
            <LaunchErr errShow={curUserInfo.avatar.errShow} text={curUserInfo.avatar.err}></LaunchErr>
          </FormItem>
          <FormItem>
            <LaunchInput 
              info={curUserInfo.nick} 
              title="Name"
              type="nick"
              inputChange={inputChange}
              inputBlur={inputBlur}></LaunchInput>
          </FormItem>
        </FormRowBetween>
        <FormItem height="165px">
          <LaunchText info={{star: '*'}} title="Banner image" margin="0 0 10px"></LaunchText>
          <NewUpLoadFiles info={curUserInfo.banner} type="banner" uploadImg={uploadImg} uploadIdImg={uploadIdImg} cssDetail={{width: '100%', height: '93px', border: '16px', row: true, fontSize: 12, title: '1652 x 220 recommended', textMargin: '0 0 0 24px'}}></NewUpLoadFiles>
          {
            curUserInfo.banner.loading && <UseLoading style={{paddingLeft: '15px'}}>uploading...</UseLoading>
          }
          <LaunchErr errShow={curUserInfo.banner.errShow} text={curUserInfo.banner.err}></LaunchErr>
        </FormItem>
        <FormItem height="208px">
          <LaunchInput 
            info={curUserInfo.introduction} 
            title="Bio"
            type="introduction"
            inputType="textarea"
            inputChange={inputChange}
            inputBlur={inputBlur}></LaunchInput>
          <TextareaLimit>{briefNum ? briefNum + ' / ' : ''}{userArt.length > 0 ? 1000 : 500}</TextareaLimit>
        </FormItem>
        <FormItem height="136px">
          <LaunchInput
            info={curUserInfo.link} 
            title="Social Media/Portfolio link"
            type="link"
            inputChange={inputChange}
            inputBlur={inputBlur}></LaunchInput>
        </FormItem>
        {/* <FormItem height="166px">
          <Text marginBottom="8px" fontSize={14} color={theme.bsText15} fontFamily="Yuanti SC" fontWeight="bold">
            Banner
          </Text>
          {
            !curUserInfo.banner.text
              ? (
                <ItemBannerHolder>
                  <img src="images/user/edit_banner.png" alt="" onClick={() => uploadImg('banner')} />
                  <div className="support">
                    {'Support: png / jpg \n Suggest size：1440 * 300'}&emsp;≤10M
                  </div>
                </ItemBannerHolder>
              )
              : (
                <ItemBanner>
                  <img src={curUserInfo.banner.text} alt="" />
                  <Row className="cover" onClick={() => uploadImg('banner')}>
                    <div className="support">
                      {'Support: png / jpg \n Suggest size：1440 * 300'}&emsp;≤10M
                    </div>
                  </Row>
                </ItemBanner>
              )
          }
          <input
            type="file"
            accept=".jpg, .png, .jpeg"
            id="banner"
            className="inputFile"
            onChange={event => {
              uploadIdImg(event, 'banner')
            }}
          />
          {
            curUserInfo.banner.loading && <UseLoading>uploading...</UseLoading>
          }
          <LaunchErr errShow={curUserInfo.banner.errShow} text={curUserInfo.banner.err}></LaunchErr>
        </FormItem> */}
        <Button isDisabled={(submit || resloading || (account !== owner)) ? true : false} onClick={submitHandle}  disabled={submit || resloading || (account !== owner)} altDisabledStyle={submit || resloading || (account !== owner)}>
          {
            resloading ? (
              <AutoRow gap="6px" justify="center">
                pending <Loader stroke="white" />
              </AutoRow>
            ) : 'Submit'
          }
        </Button>
      </PersonalWrapper>
    </>
  )
}
